import type { RouteRecordRaw } from 'vue-router';
import { lazyPage } from '@/router/lazyPage';

export const aksaraRoutes: RouteRecordRaw[] = [
  {
    path: 'dashboard',
    name: 'aksara-dashboard',
    component: lazyPage(() => import('./pages/DashboardPage.vue')),
  },
  {
    path: 'users',
    name: 'aksara-users',
    component: lazyPage(() => import('./pages/UsersPage.vue')),
  },
  {
    path: 'users/:userId/posts',
    name: 'aksara-user-posts',
    component: lazyPage(() => import('./pages/UserPostsPage.vue')),
  },
  {
    path: 'posts',
    name: 'aksara-posts',
    component: lazyPage(() => import('./pages/PostsPage.vue')),
  },
  {
    path: 'posts/:id',
    name: 'aksara-post-detail',
    component: lazyPage(() => import('./pages/PostDetailPage.vue')),
  },
  {
    path: 'config/remote',
    name: 'aksara-config-remote',
    component: lazyPage(() => import('@/features/config/pages/RemoteConfigPage.vue')),
  },
  {
    path: 'config/data',
    name: 'aksara-config-data',
    component: lazyPage(() => import('@/features/config/pages/ConfigDataPage.vue')),
  },
  {
    path: 'settings',
    name: 'aksara-settings',
    component: lazyPage(() => import('@/features/settings/pages/SettingsPage.vue')),
  },
];
